import { useDimensionsContext } from "@ui/hooks/contexts/useDimensionsContext";
import { Dimensions } from "@ui/types/Dimensions";

export function useWindowDimensions(): Dimensions {
  const { windowDimensions } = useDimensionsContext();
  return windowDimensions;
}
